import type WhiteboardController from '../../controllers/WhiteboardController';
import type ShapeImage from '../../shapes/ShapeImage';
import Shape from '../Shape';
import type CropShape from './CropShape';

const OVERLAY_OPACITY = 0.5;
class CropOverlay extends Shape {
  controller: WhiteboardController;
  clipPath: fabric.Object;
  skipRenderRecording = true;

  constructor(image: Shape<ShapeImage>) {
    super({
      controller: image.controller,
      shapeName: 'rect',

      fill: '#000000',
      angle: 0,
      opacity: OVERLAY_OPACITY,
      selectable: false,
      evented: false,
    });

    this.canvas = image.canvas;

    this.clipPath = new Shape({
      controller: image.controller,
      shapeName: 'rect',

      fill: '#000000',
      left: image.croppedLeft || image.left,
      top: image.croppedTop || image.top,
      scaleX: image.croppedScaleX || image.scaleX,
      scaleY: image.croppedScaleY || image.scaleY,
      angle: 0,
      opacity: 1,
      inverted: true,
      absolutePositioned: true,
    });

    this.clipPath.set({
      height: image.height,
      width: image.width,
    });

    this.set('clipPath', this.clipPath);
    this.updateOverlaySizeAndPosition();

    this.updateOverlaySizeAndPosition =
      this.updateOverlaySizeAndPosition.bind(this);

    this.canvas.on('pan', this.updateOverlaySizeAndPosition);
    this.canvas.on('zoom', this.updateOverlaySizeAndPosition);
    window.addEventListener('resize', this.updateOverlaySizeAndPosition);
  }

  deleted() {
    window.removeEventListener('resize', this.updateOverlaySizeAndPosition);

    if (!this.canvas) return;
    this.canvas.off('pan', this.updateOverlaySizeAndPosition);
    this.canvas.off('zoom', this.updateOverlaySizeAndPosition);
  }

  updateOverlaySizeAndPosition() {
    const { canvas } = this;
    if (!this.canvas || !canvas.vptCoords) return;

    const { x: left, y: top } = canvas.vptCoords.tl;
    const { x: right, y: bottom } = canvas.vptCoords.br;

    const width = right - left;
    const height = bottom - top;

    this.set({ left, top, height, width });
  }

  updateClipPath({ width, height, scaleX, scaleY, left, top }: CropShape) {
    // Sync the clip path with the position and dimensions of the crop
    // shape

    this.clipPath.set({
      height,
      width,
      scaleX,
      scaleY,
      left,
      top,
    });

    this.set({
      clipPath: this.clipPath,
      // Setting the clip path by itself doesn't change the dirty
      // flag on the object, set it manually to force a rerender.
      dirty: true,
    });
  }
}
export default CropOverlay;
